import LinkDetailsObject from '../assets/linkDetails.json';
import LandingPageOptionsObject from '../assets/landingPageOptions.json';

const clientId = process.env.REACT_APP_CLIENT_ID || 'default';

let clientConfig = {};
try {
  // Dynamically require the client configuration based on the build variable
  clientConfig = require(`../clients/${clientId}/config`);
} catch (error) {
  console.warn(`No specific config found for client: ${clientId}. Using default.`);
}

const defaultConfig = require('../clients/default/config');

// Merge configurations. Client config overrides default config.
export const features = {
  ...defaultConfig.features,
  ...(clientConfig.features || {})
};

// Client is fixed at build time, so these are computed once at module load.
// Nav groups with client-hidden links removed; groups left with no links are dropped.
export const visibleNavGroups = LinkDetailsObject.data
    .map((group) => ({
      ...group,
      links: group.links.filter((link) => !features.hiddenLinks.includes(link.id)),
    }))
    .filter((group) => group.links.length > 0);

// Landing page options not hidden for the client.
export const visibleLandingPageOptions = LandingPageOptionsObject.data.filter((option) => !features.hiddenLandingPageOptions.includes(option.id));
